import React from 'react';
import Loading, { LoadingSize } from '../../Loading';
import Text from '../Text/Text';
// @ts-ignore
import styles from './SavingSpinner.module.scss';

interface SavingSpinnerProps {
	tx?: string;
}

const SavingSpinner: React.FC<SavingSpinnerProps> = ({
	tx = 'base.saving',
}) => {
	return (
		<div className={styles.wrapper}>
			<Loading size={LoadingSize.SMALL} />
			<div className={styles.text}>
				<Text tx={tx} inline={true} />
				...
			</div>
		</div>
	);
};

export default SavingSpinner;
